import { FileItem, FileUploader, FileUploaderOptions } from 'ng2-file-upload';

export class FileUploaderCustom extends FileUploader {
    /**
     * Constructeur
     */
    constructor(options: FileUploaderOptions) {
        super(options);
    }

    /**
     * Surcharge la fonction upload pour faire un envoie multiple
     * @param data : Information suplementaire pour la requête
     */
    public uploadAllFiles(data: object | string): void {
        var xhr = new XMLHttpRequest();
        var sendable = new FormData();
        var fakeitem: FileItem = null;
        this.onBuildItemForm(fakeitem, sendable);

        for (const item of this.queue) {
            item.isReady = true;
            item.isUploading = true;
            item.isUploaded = false;
            item.isSuccess = false;
            item.isCancel = false;
            item.isError = false;
            item.progress = 0;
            item.withCredentials = false;

            if (typeof item._file.size !== 'number') {
                throw new TypeError('The file specified is no longer valid');
            }
            sendable.append('files', item._file, item.file.name);
        }

        if (typeof data === 'string') {
            sendable.append('data', data as string);
        } else if (data) {
            Object.keys(data).forEach((x) => {
                if (data[x] && !(data[x] instanceof Array)) {
                    sendable.append(x, data[x]);
                } else if (data[x] && data[x] instanceof Array && (data[x] as Array<string>).length > 0) {
                    (data[x] as Array<string>).forEach((item) => {
                        sendable.append(x, item);
                    });
                }
            });
        }

        if (this.options.additionalParameter !== undefined) {
            Object.keys(this.options.additionalParameter).forEach((key) => {
                sendable.append(key, this.options.additionalParameter[key]);
            });
        }

        xhr.onload = () => {
            var gist = (xhr.status >= 200 && xhr.status < 300) || xhr.status === 304 ? 'Success' : 'Error';
            var method = 'on' + gist + 'Item';
            this[method](fakeitem, xhr.response, xhr.status, null);
        };
        xhr.onerror = () => {
            this.onErrorItem(fakeitem, null, xhr.status, null);
        };

        xhr.onabort = () => {
            this.onErrorItem(fakeitem, null, xhr.status, null);
        };

        xhr.open(this.options.method || 'POST', this.options.url, true);
        xhr.withCredentials = false;

        if (this.options.headers) {
            for (var _i = 0, _a = this.options.headers; _i < _a.length; _i++) {
                var header = _a[_i];
                xhr.setRequestHeader(header.name, header.value);
            }
        }

        if (this.authToken) {
            xhr.setRequestHeader(this.authTokenHeader, this.authToken);
        }

        xhr.send(sendable);
    }
}
